import { FrameStrip } from "./FrameStrip";

import { ClipColor } from "../components/ClipColor";
import { FlattenedImage } from './FlattenedImage';

import Rectangle = createjs.Rectangle;
import Bitmap = createjs.Bitmap;

export class AbstractClipSource {
    /** cacheID of this object */
    protected _cacheId: string;

    /** returns cacheID */
    public get cacheId(): string {
        return this._cacheId;
    }

    /** container that stores all the frames of clip*/
    protected _framesStrip: FrameStrip = new FrameStrip();

    public get frameStrip(): FrameStrip {
        return this._framesStrip;
    }

    /** color used for debug informations. */
    protected debugColor: number;

    constructor() {
    }

    protected _colorData: ClipColor[];

    public get colorID(): string {
        if (this._colorData && this._colorData.length > 0) {
            let colorIDString: string = "";

            for (let i: number = 0; i < this._colorData.length; i++) {
                colorIDString += this._colorData[i].colorID;
            }

            return colorIDString;

        } else {
            return null;
        }
    }

    protected _clipBounds: Rectangle = new Rectangle();

    public get clipBounds(): Rectangle {
        return this._clipBounds;
    }

    protected addToClipBounds(bounds: Rectangle): void {
        if (!this._clipBounds) {
            this._clipBounds = new Rectangle();
        }
        this._clipBounds = this._clipBounds.union(bounds);
    }


    public destroy(): void {
        if (this._framesStrip) {
            this._framesStrip.destroy();
            this._framesStrip = null;
        }
    }
}
